import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// ── ADD YOUR GOOGLE LINKS HERE ──────────────────────────────────────────────
const GMB_PROFILE_LINK = "https://www.google.com/search?q=Rai+%26+Associates&stick=H4sIAAAAAAAA_-NgU1I1qDC2NEhONTazMDRPMjZNSrK0MqgwSU5JTk2ytDBJMrE0NzExWcQqEJSYqaCm4FhcnJ-cmViSWgwATu7QmTwAAAA&hl=en-GB&mat=CVUK5D51i-5JElYBa0lj_5KaQFgjeVk54r7kISKSv6prOhQLrHZPalnJ_FPGa2MhqVLkLtWMCrIgwxx6ueUAUbZSxzWsWrp2I8exWWtZFEFN5_o3r18QLCuOn3L-mvmDgA&authuser=1"; // Your Google Business Profile link

const testimonials = [
  {
    name: "Shivam Prajapati",
    designation: "",
    feedback:
      "Rai & Associates provides reliable and professional legal services. The team is responsive, knowledgeable, and handles matters with clarity and attention to detail. Overall, a smooth and satisfactory experience.",
    rating: 5,
    reviewLink: "https://www.google.com/maps/contrib/105738207133114405546/reviews/@28.5995148,77.2896534,14z/data=!3m1!4b1!4m3!8m2!3m1!1e1?hl=en-GB&entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "Aman Singh",
    designation: "",
    feedback:
      "I had a very positive experience with Rai & Associates. The team was professional, responsive, and guided me clearly throughout the legal process.",
    rating: 5,
    reviewLink: "https://www.google.com/maps/reviews/@28.5852764,77.2467492,17z/data=!3m1!4b1!4m5!14m4!1m3!1m2!1s111217505601946708461!2s0x390ce36817b35bb9:0x4cdceb984b497444?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "Teena",
    designation: "",
    feedback:
      "Rai & Associates handled my case with great professionalism and dedication. The advocate explained every legal aspect clearly and provided proper guidance throughout the process. I really appreciated the timely updates and supportive behaviour. Highly recommended for anyone looking for reliable legal services in Delhi.",
    rating: 5,
    reviewLink: "http://google.com/maps/reviews/@28.5852764,77.2467492,17z/data=!3m1!4b1!4m5!14m4!1m3!1m2!1s113195239707969587674!2s0x390ce36817b35bb9:0x4cdceb984b497444?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D",
  },
];

// ── Google Icon SVG ──────────────────────────────────────────────────────────
const GoogleIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

// ── Star Rating ──────────────────────────────────────────────────────────────
const StarRating = ({ count = 5 }) => (
  <div className="flex items-center gap-[3px]">
    {Array.from({ length: 5 }).map((_, i) => (
      <svg
        key={i}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={i < count ? "#FBBC05" : "#E0E0E0"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);

// ── Component ────────────────────────────────────────────────────────────────
const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const current = testimonials[currentIndex];

  return (
    <section className="bg-white py-16 sm:py-24 px-4 sm:px-6 md:px-12 relative overflow-hidden font-serif">

      {/* Faint background watermark */}
      <div className="absolute bottom-6 right-6 opacity-[0.025] text-5xl font-black uppercase tracking-tighter text-black select-none pointer-events-none hidden lg:block">
        Rai & Associates
      </div>

      <div className="max-w-7xl mx-auto">

        {/* ── SECTION HEADER ── */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12 sm:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[1px] bg-black/30" />
              <span className="uppercase tracking-[0.45em] text-[10px] font-bold text-black/40">
                Client Testimonials
              </span>
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-black leading-tight">
              What Our <br />
              <span className="font-light text-black/30 italic">Clients Say</span>
            </h2>
          </div>

          {/* Google Review CTA */}
          <a
            href={GMB_PROFILE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 border border-black/10 px-5 py-3 hover:bg-black hover:text-white group transition-all duration-300 self-start sm:self-auto"
          >
            <GoogleIcon size={18} />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-black group-hover:text-white transition-colors duration-300">
              See All Reviews
            </span>
          </a>
        </div>

        {/* ── MAIN GRID ── */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 items-start">

          {/* LEFT: Navigation list */}
          <div className="lg:col-span-4 flex flex-row lg:flex-col gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {testimonials.map((t, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`flex-shrink-0 lg:flex-shrink text-left border transition-all duration-400 p-4 sm:p-5 group
                  ${currentIndex === i
                    ? "border-black bg-black text-white"
                    : "border-black/10 bg-white text-black hover:border-black/30"
                  }`}
              >
                <div className="flex items-center gap-3 mb-1">
                  <span className={`text-[10px] font-bold uppercase tracking-widest ${currentIndex === i ? "text-white/40" : "text-black/25"}`}>
                    0{i + 1}
                  </span>
                </div>
                <p className={`text-sm font-bold uppercase tracking-wide ${currentIndex === i ? "text-white" : "text-black"}`}>
                  {t.name}
                </p>
                <p className={`text-[11px] mt-0.5 ${currentIndex === i ? "text-white/50" : "text-black/40"}`}>
                  {t.designation}
                </p>
              </button>
            ))}
          </div>

          {/* RIGHT: Active Review Card */}
          <div className="lg:col-span-8 relative">

            {/* Depth frames */}
            <div className="absolute top-3 left-3 right-0 bottom-0 border border-black/5 hidden sm:block" />
            <div className="absolute top-6 left-6 right-0 bottom-0 border border-black/[0.03] hidden sm:block" />

            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="relative bg-black p-8 sm:p-12 md:p-16 shadow-[24px_24px_64px_rgba(0,0,0,0.15)]"
              >
                {/* ── Google badge top-right ── */}
                <a
                  href={current.reviewLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="absolute top-6 right-6 flex items-center gap-2 bg-white px-3 py-2 hover:bg-white/90 transition-colors duration-200 group"
                  title="View on Google"
                >
                  <GoogleIcon size={16} />
                  {/* <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-black/70 group-hover:text-black">
                    Google
                  </span> */}
                </a>

                {/* Big decorative quote mark */}
                <div className="absolute top-8 left-12 text-[7rem] font-serif leading-none text-white/[0.04] select-none pointer-events-none">
                  "
                </div>

                {/* Star rating */}
                <div className="mb-6 relative z-10">
                  <StarRating count={current.rating} />
                </div>

                {/* Feedback text */}
                <p className="text-white text-xl sm:text-2xl md:text-3xl font-serif italic leading-relaxed mb-10 relative z-10">
                  "{current.feedback}"
                </p>

                {/* Author row */}
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 relative z-10">
                  <div className="flex flex-col gap-1">
                    <div className="w-8 h-[1px] bg-white/20 mb-2" />
                    <h4 className="text-white text-base font-bold uppercase tracking-widest">
                      {current.name}
                    </h4>
                    <p className="text-white/40 text-[11px] uppercase tracking-[0.4em] font-sans">
                      {current.designation}
                    </p>
                  </div>

                  {/* Review link button */}
                  <a
                    href={current.reviewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 border border-white/15 px-4 py-2 hover:bg-white/10 transition-all duration-300 group self-start sm:self-auto"
                  >
                    <GoogleIcon size={14} />
                    <span className="text-[10px] uppercase tracking-[0.3em] text-white/50 group-hover:text-white/80 transition-colors duration-300 font-sans">
                      View Review
                    </span>
                  </a>
                </div>

                {/* Corner accent */}
                <div className="absolute bottom-0 right-0 w-12 h-12 border-r border-b border-white/10" />
              </motion.div>
            </AnimatePresence>

            {/* Dot progress indicators */}
            <div className="flex items-center gap-2 mt-6">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  className={`transition-all duration-500 rounded-full ${
                    currentIndex === i ? "w-8 h-2 bg-black" : "w-2 h-2 bg-black/15"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* ── BOTTOM GOOGLE TRUST BAR ── */}
        <div className="mt-14 sm:mt-20 border-t border-black/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <GoogleIcon size={22} />
            <div>
              <div className="flex items-center gap-2">
                <StarRating count={5} />
                <span className="text-sm font-bold text-black">5.0</span>
              </div>
              <p className="text-[11px] text-black/40 uppercase tracking-[0.3em] font-sans mt-0.5">
                Based on Google Reviews
              </p>
            </div>
          </div>

          <a
            href={GMB_PROFILE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-black text-white px-6 py-3 hover:bg-black/80 transition-all duration-300 text-[11px] uppercase tracking-[0.35em] font-bold"
          >
            <GoogleIcon size={14} />
            Leave Us a Review
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;